import { GridConfig } from "../GridConfig";
import { FabricRectangular } from "../../components/FabricRectangular";
import { DIAGRAM_EMIT_EVENTS } from "../../../../diagram/modules/DiagramEvents";
import { DiagramEventEmitter } from "../../../../diagram/modules/DiagramEventEmitter";
import { getInstanceIDFromCanvasInstance } from "../../../../diagram/diagram-assets/diagram-positioning-state";
import { CellIndependentPluginHandler } from "./CellIndependentPluginHandler";

/**
 * @description Handles the move of a cell independent plugin
 */
export class CellIndependentMoveHandler {
    draggedPlugin;

    mousePos;

    constructor(draggedPlugin, mousePos) {
        this.draggedPlugin = draggedPlugin;
        this.mousePos = mousePos;
    }

    /**
     * @description Checks to see if the mouse left the initial plugin area
     */
    mouseLeftDraggedPluginInitialPosition(mousePos) {
        const { instance } = this.draggedPlugin;
        const fabricRect = new FabricRectangular({ ...instance.size, ...instance.position });
        return !fabricRect.pointInRect(mousePos);
    }

    /**
     * @description Handles the drop of the moved plugin.
     * @param {Object} pos  - mouse pos
     * @param {Array[][]} grid - generated grid matrix
     * @param {CellIndependentPluginHandler} pluginHandler
     * @param {Object} ctx  - diagram 2d ctx
     */
    dropElement(pos, grid, pluginHandler, ctx, oldState) {
        if (!pos) return;
        if (!this.mouseLeftDraggedPluginInitialPosition(pos)) {
            return;
        }
        this.instanceId = getInstanceIDFromCanvasInstance(ctx);
        const pluginUuid = this.draggedPlugin.instance.uuid;
        const gridConfig = new GridConfig(this.instanceId);

        const oldPosition = { ...this.draggedPlugin.instance.position };
        const newPosition = {
            x: pos.x - (pos.x % gridConfig.cellWidth),
            y: pos.y - (pos.y % gridConfig.cellHeight)
        };
        const newlyCoveredCells = pluginHandler.getCoveredCells(newPosition, { width: pos.width, height: pos.height }, grid, true);
        const newlyCoveredAndAdjacentCells = pluginHandler.getCoveredCells(newPosition, { width: pos.width, height: pos.height }, grid);
        const checkForInvalidMove = newlyCoveredCells.filter(cell => this.draggedPlugin.coveredCells.indexOf(cell) === -1).filter(cell => cell && (cell.isVoid() || cell.hasContent())).length > 0;
        const evEmitter = new DiagramEventEmitter(this.instanceId);
        if (checkForInvalidMove) {
            evEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.FAILED_CONTAINER_MOVE, { pluginUUID: pluginUuid });
            return;
        }
        const oldCellsToRedraw = Object.assign([], this.draggedPlugin.coveredCells);
        this.draggedPlugin.coveredCells = newlyCoveredCells;
        this.draggedPlugin.coveredCellsAndAdjacent = newlyCoveredAndAdjacentCells;
        this.draggedPlugin.instance.clear();

        const payload = { oldPosition, newPosition };
        evEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.CONTAINER_MOVED, payload, true, !!oldState);

        this.draggedPlugin.instance.update({ position: newPosition }, { selected: true });
        pluginHandler.markCellsAsVoidOrUnvoid(this.draggedPlugin.coveredCells, true);
        this.draggedPlugin.instance.draw();
        oldCellsToRedraw.forEach(cell => {
            if (cell) {
                cell.update({}, { void: false, selected: false, dragHover: false });
                cell.draw(null, true);
            }
        });
        pluginHandler.plugins.set(pluginUuid, this.draggedPlugin);
        if (oldState) {
            evEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.MULTIPLE_ACTIONS_HAPPENED, [
                { event: DIAGRAM_EMIT_EVENTS.CONTAINER_MOVED, oldState, payload }
            ], true, false);
        }
    }

    /**
     * @description returns plugin size
     */
    getSize() {
        const pluginSize = this.draggedPlugin.instance.size;
        return pluginSize;
    }
}
